import { computed, decorate, observable } from "mobx";

class CurrentUserStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    this.user = null;
    this.customer = null;

    if (!this.rootStore) throw new Error("rootStore cannot be null");
  }

  get loggedIn() {
    return this.user !== null;
  }
}

decorate(CurrentUserStore, {
  user: observable,
  customer: observable,
  loggedIn: computed
});

export default CurrentUserStore;



// WEBPACK FOOTER //
// ./src/Stores/CurrentUserStore.js